import { Injectable } from '@angular/core';

export interface CounterUpConfigArgs {
  delay?: number;
  time?: number;
  beginAt?: number;
}
export class CounterUpConfig implements CounterUpConfigArgs {

  delay = 10;
  time = 100;
  beginAt = 0;
/**
 * @param {?=} config
 */
constructor(config: CounterUpConfigArgs = {}) {
    Object.assign(this, config);
  }

}

function CounterUpConfig_tsickle_Closure_declarations() {
/** @type {?} */
CounterUpConfig.prototype.delay;
/** @type {?} */
CounterUpConfig.prototype.time;
/** @type {?} */
CounterUpConfig.prototype.beginAt;
}

